import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { css, keyframes } from '@emotion/react';

const fadeIn = keyframes`from{opacity:0} to{opacity:1}`;
const fadeOut = keyframes`from{opacity:1} to{opacity:0}`;

export const Fade = ({
  show,
  display,
  position = 'static',
  zIndex = 'auto',
  duration = 0.3,
  timingFunction = 'ease-in-out',
  children
}) => {
  const [shouldRender, setRender] = useState(show);

  useEffect(() => {
    if (show) {
      setRender(true);
    }
  }, [show]);

  const onAnimationEnd = () => {
    if (!show) {
      setRender(false);
    }
  };

  const styles = {
    fade: css`
      animation: ${show ? fadeIn : fadeOut} ${duration}s ${timingFunction};
      display: ${display};
      position: ${position};
      z-index: ${zIndex};
    `
  };

  return (
    shouldRender && (
      <div css={styles.fade} onAnimationEnd={onAnimationEnd}>
        {children}
      </div>
    )
  );
};

Fade.propTypes = {
  show: PropTypes.bool.isRequired,
  display: PropTypes.string,
  position: PropTypes.string,
  zIndex: PropTypes.string,
  duration: PropTypes.number,
  timingFunction: PropTypes.string,
  children: PropTypes.node.isRequired
};
